export default [
	{
		id: 'step1',
		label: 'cancelled.airline'
	},
	{
		id: 'notify-taxes-and-fees',
		label: 'cancelled.customer'
	}
]
